import { render, staticRenderFns } from "./ed-designer-rectangle.component.vue?vue&type=template&id=0c2ff766&scoped=true&"
import script from "./ed-designer-rectangle.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer-rectangle.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer-rectangle.component.scss?vue&type=style&index=0&id=0c2ff766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ff766",
  null
  
)

export default component.exports